@if (dataMode != 'summary') {
  <button [style.z-index]="2" type="button" (click)="drawChart('summary')" tooltip="Go Back" class="btn btn-outline-secondary btn-sm float-left position-relative m-2">
    <i class="fas fa-arrow-left"></i>
  </button>
}

<div id="chart_cleanid_summary"></div>

